<template>
    <div style="text-align: center">
        <v-icon :size = "size" :color = "color" class="document-icon mt-1">
            {{ icon }}
        </v-icon>
    </div>
</template>

<script>
export default {
    name: "CIncDocumentIcon",

    props: {
        document: {

        },

        size: {

        },

        color: {
            required: false,
            default: () => {
                return "primary"
            }
        }
    },

    computed: {
        icon () {
            if ( this.document.stamped) {
                return "mdi-stamper";
            }

            switch (this.document.type.symbol) {
                case "fa-file":
                    switch (this.document.contentType) {
                        case "application/vnd.ms-outlook":
                        case "application/octet-stream":
                            return "mdi-email-outline"
                        case "application/pdf":
                            return "mdi-file-pdf-box-outline";
                        case "image/png":
                        case "image/jpeg":
                        case "image/gif":
                            return "mdi-image-outline";
                    }
                    break;
                case "fa-envelope":
                    return "mdi-email-outline"
                case "fa-file-pdf":
                    return "mdi-file-pdf-box-outline";
                case "fa-image":
                    return "mdi-image-outline";
                case "fa-send":
                    return "mdi-email-send-outline";
            }

            return "";
        }
    },

}
</script>

<style scoped>

</style>